import React, { FC } from 'react';
import Styles from './Styles';
import Concessionaire from './Concessionaire';

const StateManager: FC = () => {
  return (
    <>
      <Concessionaire />
      <Styles />
    </>
  );
};

export default StateManager;
